export default (state = 'map', action) => {
    let { type, payload } = action
    switch (type) {
        case 'SELECTED_TAB':
            return payload
        case 'LOGOUT':
            return {}
        default:
            return state
    }
}
